import { useEffect } from 'react';
import { useTrackPageVisit as useTrackPageVisitMutation } from 'api/account/useTrackPageVisit';
import { MemberProgram, OnboardingPage } from 'app-pages/pages/constants';

/**
 * FIXME: Delete this hook as soon as we start using the `useNextStep` hook to
 * figure out the next step in the onboarding flow.
 */
export const useTrackPageVisit = (page: OnboardingPage, program: MemberProgram, patientId?: string) => {
  const { mutateAsync: trackPageVisit } = useTrackPageVisitMutation();

  useEffect(() => {
    if (patientId) {
      trackPageVisit({
        page,
        patientId,
        program,
      });
    }
  }, [trackPageVisit, page, patientId, program]);
};
